<template>
  <div>
    <template v-if="isShowBtn">
      <div class="query_wapper" style="margin-bottom:30px">
        <el-button-group>
          <el-button
            @click="selectType(1)"
            :class="switchType === 1?'select':'normal'"
            style="width:100px"
          >报名表</el-button>
          <el-button @click="selectType(2)" :class="switchType === 2?'select':'normal'">运动员照片</el-button>
        </el-button-group>
        <el-select
          :popper-append-to-body="false"
          style="margin:0 20px;width:200px;"
          v-model="headValue.year"
          @change="getMatch"
        >
          <el-option
            v-for="(item,index) in yearLists"
            :value="item.value"
            :label="item.label"
            :key="index"
          ></el-option>
        </el-select>
        <el-select
          style="width:220px"
          :popper-append-to-body="false"
          v-model="headValue.matchName"
          @change="$event=>getSignDetail($event)"
        >
          <el-option
            v-for="(item,index) in matchList"
            :key="index"
            :value="item.id"
            :label="item.matchName"
          ></el-option>
        </el-select>
        <el-button
          style="width:90px;margin:0 10px 0 20px;"
          v-if="false"
          @click="print"
          type="warning"
        >打印</el-button>
        <el-button style="width:90px" type="primary" v-if="false" @click="exportPdf">导出</el-button>
      </div>
      <template v-if="switchType === 1">
        <el-form v-if="false" :model="query" ref="form" :rules="rules" label-width="80px">
          <el-form-item label="赛事名称" prop="raceName">
            <el-select
              :popper-append-to-body="false"
              style="width:300px"
              v-model="query.raceName"
              placeholder="请选择赛事"
              @change="selectMatch"
            >
              <el-option
                v-for="(item,index) in matchList"
                :key="index"
                :value="item.id"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-table style="width:100%;margin-top:40px" border :data="tableData">
          <el-table-column label="序号" align="center" type="index" width="60"></el-table-column>
          <el-table-column label="单位" align="center" width="100" prop="schoolName"></el-table-column>
          <el-table-column label="身份" align="center" width="100">
            <template slot-scope="{row}">
              <span>{{getIdentity(row.identity)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="兼任" align="center" width="100" prop="partTime"></el-table-column>
          <el-table-column label="性别" align="center" width="60" prop="gender"></el-table-column>
          <el-table-column label="组别" align="center" width="60">
            <template slot-scope="{row}">
              <span>{{row.group}}</span>
            </template>
          </el-table-column>
          <el-table-column label="姓名" align="center" width="100">
            <template slot-scope="{row}">
              <span>{{row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="姓名全拼" align="center" width="160" prop="pinyin"></el-table-column>
          <el-table-column label="身份证号码" align="center" width="160" prop="idCard"></el-table-column>
          <el-table-column label="出生日期" align="center" width="110">
            <template slot-scope="{row}">
              <span>{{row.birthday}}</span>
            </template>
          </el-table-column>
          <el-table-column label="注册号码" align="center" width="140" prop="registerNumber"></el-table-column>
          <el-table-column label="比赛号" align="center" width="100" prop="matchNumber"></el-table-column>
          <el-table-column label="分计单位" align="center" width="100" prop="subUnit"></el-table-column>
          <el-table-column label="教练" align="center" width="80">
            <template slot-scope="{row}">
              <span>{{getCoachName(row.coachId)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" width="80" align="center" prop="remarks"></el-table-column>
          <el-table-column label="距离" width="80" align="center" prop="distance"></el-table-column>
          <el-table-column label="泳式" width="100" align="center" prop="swimmingStyle"></el-table-column>
          <el-table-column label="报名成绩" width="80" align="center" prop="score"></el-table-column>
          <el-table-column label="测验" width="80" align="center" prop="test"></el-table-column>
          <el-table-column label="特殊标记" width="80" align="center" prop="mark"></el-table-column>
        </el-table>
        <footer v-if="reviewState === 1">
          <el-button
            :loading="loadingData.submitLoading"
            class="btns"
            style="width:90px"
            @click="operation('agree')"
          >同意</el-button>
          <el-button
            @click="operation('reject')"
            :loading="loadingData.saveLoading"
            class="btns"
            style="margin:0 20px;width:90px"
          >驳回</el-button>
        </footer>
        <footer v-else>
          <span style="font-size:22px">审核状态：</span>
          <span
            :style="{color:reviewState === 0?'#1E63B0':reviewState === 2?'#FD6666':'#1CC28C'}"
            style="font-size:18px"
          >{{reviewState === 0?'报名未提交':reviewState === 2?'审核未通过':'审核已通过'}}</span>
        </footer>
      </template>
      <athletesPhoto v-else :details="athleteData"></athletesPhoto>
    </template>
    <template v-else>
      <div class="query_wapper">
        <el-select
          :popper-append-to-body="false"
          style="margin:0 20px;"
          v-model="headValue.year"
          @change="getMatch"
        >
          <el-option
            v-for="(item,index) in yearLists"
            :value="item.value"
            :label="item.label"
            :key="index"
          ></el-option>
        </el-select>
        <el-select
          :popper-append-to-body="false"
          v-model="headValue.matchName"
          @change="$event=>getSignDetail($event)"
        >
          <el-option
            v-for="(item,index) in matchList"
            :key="index"
            :value="item.id"
            :label="item.matchName"
          ></el-option>
        </el-select>
      </div>
      <div style="padding:160px 0 0 250px">
        <img src="../../assets/img/signUp/no_data.png" alt />
      </div>
    </template>
    <div
      v-if="!hideMask"
      style="width:100%;height:100vh;position:fixed;background:#fff;top:106px;z-index:999999;left:290px;"
    ></div>
  </div>
</template>
<script>
import {
  getSignDetailBySchool,
  signDetail,
  getSignListBySchool,
  schoolAudit
} from "@/api/sign-up-match";
import { getMatchList } from "@/api/sports-management";
import athletesPhoto from "./components/athletes-photo";
import { table, message, selectiveYear } from "@/common/js/mixins";
import { getSession } from "@/utils/storage.js";
import { getCoachList, getAthleteList } from "@/api/athletes.js";
import { addSwimming, updateSwimming } from "@/api/swimming.js";
export default {
  mixins: [table, message, selectiveYear],
  components: {
    athletesPhoto
  },
  data() {
    return {
      switchType: 1,
      athleteData: {},
      query: {
        raceName: "",
        matchId: "",
        id: ""
      },
      headValue: {
        year: "",
        matchName: ""
      },
      identityList: [
        {
          label: "领队",
          value: 3
        },
        {
          label: "教练",
          value: 2
        },
        {
          label: "工作人员",
          value: 4
        },
        {
          label: "医生",
          value: 5
        },
        {
          label: "运动员",
          value: 1
        },
        {
          label: "代表队",
          value: 6
        }
      ],
      loadingData: {
        submitLoading: false,
        saveLoading: false
      },
      userInfo: JSON.parse(getSession("userInfo")),
      reviewState: 1,
      hideMask: false,
      isShowBtn: true,
      matchList: [],
      athleteList: [],
      currentProject: {},
      titles: [
        "identity",
        "partTime",
        "gender",
        "group",
        "name",
        "pinyin",
        "idCard",
        "birthday",
        "registerNumber",
        "coachId",
        "remarks",
        "distance",
        "swimmingStyle",
        "score",
        "test",
        "mark"
      ],
      tableData: [],
      editable: [],
      rules: {
        raceName: [
          {
            required: true,
            message: "赛事名称不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    // 获取教练员名称
    getCoachName() {
      return data => {
        let coachName = "";
        this.coachList.filter(item => {
          if (item.id === data) coachName = item.name;
        });
        return coachName;
      };
    },
    // 获取身份名称
    getIdentity() {
      return data => {
        let identityName = "";
        this.identityList.filter(item => {
          if (item.value === data) identityName = item.label;
        });
        return identityName;
      };
    }
  },
  methods: {
    // 切换按钮组
    selectType(switchType) {
      if (switchType === 2) {
        let arr = [];
        this.details.swimAthleteList.filter(item => {
          if (item.identity === 1) {
            arr.push(item);
          }
        });
        this.athleteData = JSON.parse(JSON.stringify(this.details));
        this.$set(this.athleteData, "swimAthleteList", [...arr]);
      }
      this.switchType = switchType;
    },
    //   同意驳回
    operation(type) {
      let id = null;
      this.matchList.filter(item => {
        if (item.id === this.headValue.matchName) id = item.matchId;
      });

      if (type === "agree") this.loadingData.submitLoading = true;
      else this.loadingData.saveLoading = true;
      schoolAudit({
        id: this.query.id,
        state: type === "agree" ? 3 : 2
      })
        .then(res => {
          this.openSuccess(type === "agree" ? "审核成功！" : "驳回成功！");
          if (type === "agree") this.loadingData.submitLoading = false;
          else this.loadingData.saveLoading = false;
          this.$router.push({
            path: "/swimming/swimming-registration-form-view",
            query: {
              id,
              year: this.headValue.year
            }
          });
        })
        .catch(err => {
          if (type === "agree") this.loadingData.submitLoading = false;
          else this.loadingData.saveLoading = false;
        });
    },
    // 获取教练员列表
    getCoachLists() {
      getCoachList({})
        .then(res => {
          this.coachList = [...res];
          res.filter(item => {
            item.disabled = false;
          });
          this.otherCoachList = [...res];
        })
        .catch(err => {});
    },
    // 获取赛事列表
    getMatch() {
      getSignListBySchool({
        project: 4,
        year: this.headValue.year
      })
        .then(res => {
          if (res.length > 0) {
            this.matchList = res;
            this.headValue.matchName = res[0].id;
            this.makeTable(res[0].count);
            this.getSignDetail(res[0].id);
          } else {
            this.matchList = [];
            this.headValue.matchName = "";
            this.details = {};
          }
          this.isShowBtn = res.length === 0 ? false : true;
          this.hideMask = true;
        })
        .catch(err => {
          if (err.data.msg === "当前没有赛事") {
            this.isShowBtn = false;
          }
          this.hideMask = true;
        });
    },
    // 选择赛事
    selectMatch(value) {
      Object.assign(this.query, this.$options.data().query);
      this.athleteList = [];
      this.$refs.form.resetFields();
      let data = {};
      this.matchList.filter(item => {
        if (item.id === value) data = item;
      });
      this.currentProject = data;

      Object.assign(this.query, {
        matchId: data.id,
        raceName: value
      });
      this.getSignDetail(value);
    },
    // 获取当前赛事运动员列表（草稿）
    getAthleteListByDraft() {
      return new Promise((resolve, reject) => {
        getAthleteList({
          pageNo: 1,
          pageSize: 999,
          effective: 1,
          isPass: 1,
          gender:
            this.currentProject.gender === -1 ? "" : this.currentProject.gender
        })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取详情，如果有数据，则表示已经提交或草稿数据，如果审核已通过，则修改表格显示数量
    getSignDetail(id) {
      signDetail({ project: 4, id })
        .then(res => {
          if (res) {
            this.makeTable(res.count > res.swimAthleteList.length?res.count:res.swimAthleteList.length);
            this.details = res;
            this.selectType(this.switchType);
            this.reviewState = res.state;
            Object.assign(this.query, {
              id: res.id,
              raceName: res.matchName
            });
            this.getAthleteListByDraft()
              .then(data => {
                this.athleteList = [...data.list];
                /**
                 * 循环list,当身份为1时,则赋值运动员id及其关联项
                 * 身份为2,3,4,5,6(教练员,领队,工作人员,医生,代表队)时,则赋值与其对应项
                 */
                
                res.swimAthleteList.filter((item, index) => {
                  if (item.identity == 1) {
                    Object.assign(this.tableData[index], {
                      athleteId: item.athleteId,
                      identity: item.identity,
                      coachId: item.coachId,
                      group: item.group,
                      remarks: item.remarks,
                      distance: item.distance,
                      swimmingStyle: item.swimmingStyle,
                      score: item.score,
                      test: item.test,
                      mark: item.mark
                    });
                    this.selectAthlete(item.athleteId, index, "name", true);
                  } else if (
                    item.identity == 2 ||
                    item.identity == 3 ||
                    item.identity == 4 ||
                    item.identity == 5
                  ) {
                    Object.assign(this.tableData[index], {
                      identity: item.identity,
                      partTime: item.partTime,
                      gender: item.gender,
                      name: item.name,
                      pinyin: item.pinyin,
                      subUnit: item.subUnit,
                      remarks: item.remarks,
                      matchNumber: item.matchNumber,
                      mark: item.mark,
                      test: item.test
                    });
                  } else {
                    Object.assign(this.tableData[index], {
                      identity: item.identity,
                      partTime: item.partTime,
                      gender: item.gender,
                      group: item.group,
                      subUnit: item.subUnit,
                      matchNumber: item.matchNumber,
                      remarks: item.remarks,
                      distance: item.distance,
                      swimmingStyle: item.swimmingStyle,
                      score: item.score,
                      mark: item.mark,
                      test: item.test
                    });
                  }
                });
              })
              .catch(err => {});
          }
        })
        .catch(err => {});
    },
    // 选择运动员
    selectAthlete(value, num, col, details = false) {
      if (value) {
        // this.athleteList.filter((item, index) => {
        //   this.$set(this.athleteList[index], "disabled", false);
        // });
        let arr = [];
        if (!details) this.$set(this.tableData[num], "athleteId", "");
        this.tableData.filter((item, i) => {
          for (let j = 0; j < this.athleteList.length; j++) {
            if (
              item.name === this.athleteList[j].id ||
              item.athleteId === this.athleteList[j].id
            ) {
              // this.$set(this.athleteList[j], "disabled", true);
              this.$set(this.athleteList[j], "numbers", i);
              arr.push(this.athleteList[j]);
              break;
            }
          }
        });

        arr.filter((item, i) => {
          for (let t in item) {
            if (this.tableData[item.numbers].hasOwnProperty(t)) {
              if (t !== "coachId") {
                if (t === "gender")
                  this.$set(
                    this.tableData[item.numbers],
                    t,
                    item[t] === 0 ? "女子" : "男子"
                  );
                else if (t === "group") {
                } else if (t === "birthday") {
                  this.$set(this.tableData[item.numbers], t, item.birthdayText);
                } else if (t !== "remarks")
                  this.$set(this.tableData[item.numbers], t, item[t]);
              }
            }
            Object.assign(this.tableData[item.numbers], {
              athleteId: item.id,
              pinyin: item.nameSpell
            });
          }
        });
      }
    },
    // 根据赛事限制人数生成表格
    makeTable(count = this.currentProject.count) {
      this.tableData = [];
      this.editable = [];
      for (let i = 0; i < count; i++) {
        this.tableData.push({
          schoolName: this.userInfo.schoolName,
          athleteId: "",
          identity: "",
          partTime: "FALSE",
          gender: "",
          group: "",
          name: "",
          pinyin: "",
          idCard: "",
          birthday: "",
          registerNumber: "",
          matchNumber: "",
          subUnit: "",
          coachId: "",
          remarks: "",
          distance: "",
          swimmingStyle: "",
          score: "99:99:99",
          test: "FALSE",
          mark: "FALSE"
        });
        let obj = {};
        this.titles.filter(temp => {
          obj[temp] = false;
        });
        this.editable.push(obj);
      }
    },
  },
  mounted() {
    this.getYearLists(this.headValue, this.getMatch);
    this.getCoachLists();
  }
};
</script>
<style lang="less" scoped>
footer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 60px;
  .btns {
    margin: 0;
    color: #1e63b0;
    border: 1px solid #1e63b0;
  }
}
.select {
  background: #1e63b0;
  color: #fff;
}
.normal {
  background: transparent;
  color: #999;
}
</style>